import { render, staticRenderFns } from "./orderDetailDialog.vue?vue&type=template&id=3b589e43"
import script from "./orderDetailDialog.vue?vue&type=script&lang=js"
export * from "./orderDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./orderDetailDialog.vue?vue&type=style&index=0&id=3b589e43&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports